import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Logo from "../../../assets/LOGO_bg.png";
import swal from "sweetalert";
import "./style.scss";

import { useSelector, useDispatch } from "react-redux";
import {
  HANDLE_ERROR,
  AUTH_REGISTER,
} from "../../../services/auth/actionTypes";
import { authRegister } from "../../../services/auth/actions";
import Loader from "../../../components/Loader2";

const Register = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "Admin",
  });
  const { error, isLoading, isRegistered } = useSelector(({ authState }) => ({
    isLoading: authState.isLoading,
    isRegistered: authState.isRegistered,
    error: authState.error,
  }));

  const register = () => {
    if (
      data.firstName.length === 0 ||
      data.lastName.length === 0 ||
      data.email.length === 0 ||
      data.password.length === 0
    ) {
      swal("Form Error", "Please fill all fields correctly", "warning");
    } else {
      dispatch(authRegister(data));
    }
  };

  const handleInput = (e) => {
    if (e.target.value) {
      setData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  useEffect(() => {
    if (error) {
      swal("Server Error", error.message || "Unkown Error Occurred", "error");
      dispatch({ type: HANDLE_ERROR, error: null });
    }
    if (isRegistered) {
      dispatch({ type: AUTH_REGISTER, payload: false });
      history.push("/login");
    }
  }, [error, isRegistered, dispatch, history]);

  return (
    <div className="register_container" style={{ height: window.innerHeight }}>
      <div className="register_box">
        {/* Logo */}
        <div className="logo">
          <img src={Logo} alt="bevoice" />
        </div>
        {/* Vertical Seperator */}
        <div className="vertical_seperator"></div>
        {/* Mail register form */}
        <div className="register_form">
          {/* Titles */}
          <div>
            <div className="title">Welcome to Bevoice!</div>
            <div className="subtitle">
              To enojoy our journey, please insert your e-mail and password.
            </div>
          </div>
          <div>
            {/* Email / Password Inputs */}
            <input
              type="fname"
              name="firstName"
              id="register_fname"
              placeholder="FIRST NAME"
              onChange={handleInput}
            />
            <input
              type="lname"
              name="lastName"
              id="register_lname"
              placeholder="LAST NAME"
              onChange={handleInput}
            />
            <input
              type="email"
              name="email"
              id="register_email"
              placeholder="E-MAIL"
              onChange={handleInput}
            />
            <input
              type="password"
              name="password"
              id="register_password"
              placeholder="PASSWORD"
              onChange={handleInput}
            />
            <input
              type="password"
              name="cpassword"
              id="register_cpassword"
              placeholder="CONFIRM PASSWORD"
            />
            <input
              type="radio"
              name="role"
              id="admin_role"
              value="admin"
              onChange={handleInput}
              checked
            />
            <label htmlFor="admin_role">Admin</label>
            <input
              type="radio"
              name="role"
              id="user_role"
              onChange={handleInput}
              value="user"
            />
            <label htmlFor="user_role">User</label>
          </div>
          <div className="register_buttons">
            {/* Login & Register buttons */}
            <button id="login_btn" onClick={() => history.push("/login")}>
              Login
            </button>
            <button id="register_btn" onClick={() => register()}>
              {isLoading ? <Loader size="sm" color="#fff" /> : "Register"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
